import {
  Analytics,
  Organization,
  PaginatedUsers,
  UsersParams,
} from '@components/pages/Organization/types';
import {
  api_organization_active_users_path,
  api_organization_analytics_path,
  api_organization_archived_users_path,
  api_organization_details_path,
} from '@routes';

import request from './request';

export const ORGANIZATION_DETAILS_KEY = 'ORGANIZATION_DETAILS_KEY';
export const ORGANIZATION_ANALYTICS_KEY = 'ORGANIZATION_ANALYTICS_KEY';
export const ORGANIZATION_SEARCH_USERS_KEY = 'ORGANIZATION_SEARCH_USERS_KEY';
export const ACTIVE_USERS_KEY = 'ACTIVE_USERS_KEY';
export const ARCHIVED_USERS_KEY = 'ARCHIVED_USERS_KEY';

/**
 * Fetches organization details.
 */
export async function getOrganizationDetails(): Promise<Organization> {
  const response = await request('get', api_organization_details_path());
  return response.organization;
}

/**
 * Fetches organization analytics.
 */
export async function getOrganizationAnalytics(): Promise<Analytics> {
  const response = await request('get', api_organization_analytics_path());
  return response.analytics;
}

export async function getActiveUsers({
  pageParam = 1,
  searchTerm,
}: UsersParams): Promise<PaginatedUsers> {
  const response = await request('get', api_organization_active_users_path(), {
    page: pageParam,
    search: searchTerm,
  });
  return response;
}

export async function getArchivedUsers({
  pageParam = 1,
  searchTerm,
}: UsersParams): Promise<PaginatedUsers> {
  const response = await request('get', api_organization_archived_users_path(), {
    page: pageParam,
    search: searchTerm,
  });
  return response;
}
